import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Loading from '../../components/Loading';
import Meta from "../../components/Meta";

import Data from '../../../repository';
import { loginSchema } from '../../../validation/schemas';

import styles from '../../../styles/Entry.module.scss';

function Login() {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [loading, setLoading] = useState(false);
	const [serverError, setServerError] = useState(null);

	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue
	} = useForm({
		resolver: yupResolver(loginSchema),
		defaultValues: {
			email: '',
			password: ''
		}
	});

	const onSubmit = async (data) => {
		setLoading(true);
		setServerError(null);

		try {
			const result = await Data.login(data.email, data.password);

			if (result.data.token === "password-reset") {
				alert(`We've sent you a link to set a new password because we recently re-launched our booking system. Please check your emails and follow the enclosed link.`);
			} else {
				localStorage.setItem("token", result.data.token);
				window.location.href = searchParams.get("referer") ? searchParams.get("referer") : '/';
			}
		} catch (error) {
			setValue('password', '');
			setServerError(error.response?.data?.message || 'An error occurred. Please try again.');
		} finally {
			setLoading(false);
		}
	}

	return (
		<>
			<Meta title="Login" />

			<div>
				{serverError &&
					<div className={styles.error}>
						<p>{serverError}</p>
					</div>
				}

				<h1>{searchParams.get("referer")?.includes('/join/') ? 'Login to your account below to accept your booking invitation.' : 'Login'}</h1>

				<form onSubmit={handleSubmit(onSubmit)}>
					<div>
						<input
							type="email"
							placeholder="Email Address"
							{...register('email')}
							maxLength={255}
							className={errors.email ? 'input-error' : ''}
						/>
						{errors.email && <p className={styles.fieldError}>{errors.email.message}</p>}
					</div>
					<div>
						<input
							type="password"
							placeholder="Password"
							{...register('password')}
							maxLength={255}
							className={errors.password ? 'input-error' : ''}
						/>
						{errors.password && <p className={styles.fieldError}>{errors.password.message}</p>}
					</div>
					<button className="btn btnPrimary" disabled={loading}>
						{loading ?
							<Loading button={true} />
							:
							`Login`
						}
					</button>
				</form>

				<div className={styles.alternatives}>
					<Link to="/entry/forgotten-password">Forgotten Password?</Link>
					<Link to="/entry/create-account">Don't have an account yet?</Link>
				</div>
			</div>
		</>
	);
}

export default Login;
